import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MapInformationService } from 'src/app/services/map-information.service';
import { SalesProjectService } from 'src/app/services/sales-project.service';
import { DriveserviceService } from 'src/app/services/driveservice.service';
import { EmployeesService } from 'src/app/services/employees.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EstimateService } from 'src/app/services/estimate.service';
import { ProjectService } from 'src/app/services/project.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'ng-uikit-pro-standard';
import DataGrid from "devextreme/ui/data_grid";

@Component({
  selector: 'app-project-attached-document',
  templateUrl: './project-attached-document.component.html',
  styleUrls: ['./project-attached-document.component.scss']
})
export class ProjectAttachedDocumentComponent implements OnInit {

  @Output() omitirsave2 = new EventEmitter<any>();
  @Input() GalleryImages: boolean = true;
  @Input() showTabs: any;
  @Input() insertDocument: any;
  @Input() deleteDocument: any;
  @Input() getDocument: any;
  @Input() projectid: any;
  @Input() nameModule: any;
  @Input() editParts: any;
  @Input() itemid2: any;
  @Input() itemid: any;

  @ViewChild('GridDocuments', { static: false }) GridDocuments: DxDataGridComponent;

  private _itemid: number;

  popupNewDoc = false;
  _documentForm: FormGroup;
  currentCustomerid = localStorage.getItem('customerid');

  documentTypeSelect = [];
  employeeSelect = [];
  opeitemid: any;

  popupDocument = false;
  filterAttachedDocument = {
    name: '',
    revision: '',
    documentType: [],
    createby: []
  }

  value: any[] = [];
  documentDataSource = [];
  documentDataSourceOriginal = [];
  settings: any = {};
  ChangeBase64: any;

  selectedFile: any="";
  attachment:any="";
  actionDocument = 'New Document';
  showModalDelete:boolean=false
  idDocument:any

  File:File;
  valueDocument: any[] = [];

  cancelButton: any;
  saveButton: any;
  saveNewButton: any;
  imagesPicDataSource: any = [''];
  imagenFullScreen:any=""
  openModalFullScreen:boolean=false
  tipoimagen:any
  changeBase64:boolean= true
  base64Imagenes:any[]=[{
    tipo: 'jpg',
    base64: '../../../../assets/img/noimage.jpeg'
  }]
  dataSource10: any;

  editLinkButton: any;
  externalLink: any = '';
  previewFile: any;
  showPreviewImage: boolean = false;

  optionsFile: any[] = ['Upload File to Cube','Select External File'];
  valueOptionsFile = this.optionsFile[0];
  uploadingFile: boolean;
  changeRadio: any = null;

  selectedLink: any;

  progress: number = 0;

  modalCookies: boolean = false;
  dominioactual: any;

  selectedTabPopup: any = 0;

  disableIconLink: boolean = false;

  tabsClass: any = "col-md-12";
  ToEmployeeDocument: boolean = false;
  ServiceSite: boolean = false;

  constructor(
    private toast: ToastService,
    private sanitizer: DomSanitizer,
    private employee: EmployeesService,
    private ProjectService: ProjectService,
    private estimateService: EstimateService,
    private appConfigService: AppConfigService,
    private salesProjectService: SalesProjectService,
    private MapInformationService:MapInformationService,
    private googleDrivePickerService: DriveserviceService,
    private translate:TranslateService
  ) {

    // this.ServiceSite = false

    this.imagesPicDataSource = [''];
    this.settings.dateFormat = this.appConfigService.dateFormat;

    this.initDocumentForm();

    this.editLinkButton = {
      icon: 'fa fa-link',
      type: 'default',
      onClick: () => {
        window.open(this.externalLink, "_blank");
      },
    }

    this.cancelButton = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupDocument = false;
        this.valueDocument=[]
      },
    };

    this.saveButton = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.submitDocument(true)
      },
      disabled:[this._documentForm.invalid]
    };

    this.saveNewButton = {
      text: this.translate.instant('btnSaveNew'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.submitDocument()
      },
      disabled:[this._documentForm.invalid]
    };

    DataGrid.defaultOptions({
      device: { deviceType: "phone" },
      options: {
        columnAutoWidth: true,
        columnHidingEnabled: true,
        wordWrapEnabled: false,
        rowAlternationEnabled: false
      }
    });

    DataGrid.defaultOptions({
      device: { deviceType: "desktop" },
      options: {
        columnAutoWidth: true,
        columnHidingEnabled: false
      }
    });

    this.ProjectService.GetGridConfiguration(this.gridId).subscribe(result=>{
      console.log(result)
      if(result && result.length != 0){
        this.actualState = result[0];
      }else{
        this.actualState = 0;
      }
      this.actualState.FILTERCONFIG
      let finalFilter = this.actualState.FILTERCONFIG == "" || this.actualState.FILTERCONFIG == undefined ? null : JSON.parse(this.actualState.FILTERCONFIG)
      let finalColumn = this.actualState.COLUMNCONFIG == "" || this.actualState.COLUMNCONFIG == undefined ? null : JSON.parse(this.actualState.COLUMNCONFIG)
      
      if(finalFilter){ this.filterValue = finalFilter; }

      if(finalColumn){
        localStorage.setItem('GridDocuments', this.actualState.COLUMNCONFIG);
        if(this.GridDocuments) { this.GridDocuments.instance.state({}); }
      }

      if(result && result.length != 0){
        if (result[0].EXTRACONFIG){
          if (JSON.parse(result[0].EXTRACONFIG).collased != undefined){
            if (JSON.parse(result[0].EXTRACONFIG).collased == 1){
              // this.closeParents()
              this.collased = true
            } else {
              // this.OpenParents()
              this.collased = false
            }
          }
        } 
      }
    })

  }

  ngOnInit() {

    console.log("🚀 ~ file: project-attached-document.component.ts:117 ~ ProjectAttachedDocumentComponent ~ this.getDocument:", this.getDocument)

    this.ServiceSite = this.getDocument.method == 'Get_ServiceSite_DocumentsCE' ? true : false

    if(this.nameModule == 'EditEmployeeDocument') this.ToEmployeeDocument = true
    this.getProjectDocument();
    this.initDocumentForm();

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getProjectDocument();
  }

  mddocument() {
    this.popupDocument = true;
    this.actionDocument = 'New Document';
    this.initDocumentForm();
    this.getDocumentType();
    this.getEmployee();
  }

  onCellPrepared(ev) { }

  getProjectDocument() {
    if (this.getDocument != undefined){
      if(this.getDocument.name_id2 != undefined){
        this.salesProjectService.GetDocumentsTwoParameters(this.itemid, this.getDocument, this.itemid2).subscribe(result => {
          let paths = [];
          this.documentDataSource = result.map(x=>{
            x.FILEPATH = x.filepath
            x.ATTACHMENT = x.File_Name
            paths.push(x.FILEPATH);
            x.FilePath!==undefined ? x.FILEPATH = x.FilePath : '';
            x.HYPERLINK==undefined || null ? x.HYPERLINK = '' : '';

            if(x.ATTACHMENT !== "" && x.ATTACHMENT !== undefined && x.ATTACHMENT !== null){
              let type = x.ATTACHMENT.split('.');
              if(type[1] != undefined){
                x.TYPEFILE = type[1].toUpperCase();
              } else {
                x.TYPEFILE = ""
              }
            }

            x.LOCKED == true ? x.LOCKED = "Yes" : x.LOCKED = "No"
            x.FILEPATH += x.File_Name
            // x.filepath += x.File_Name

            return x;
          });
          this.documentDataSourceOriginal = this.documentDataSource;
        },error=>{
        });
      } else {
        this.salesProjectService.GetDocuments(this.itemid, this.getDocument).subscribe(result => {
          let paths = [];
          this.documentDataSource = result.map(x=>{
            paths.push(x.FILEPATH);
            x.FilePath!==undefined ? x.FILEPATH = x.FilePath : '';
            x.HYPERLINK==undefined || null ? x.HYPERLINK = '' : '';

            if(x.ATTACHMENT !== "" && x.ATTACHMENT !== undefined && x.ATTACHMENT !== null){
              let type = x.ATTACHMENT.split('.');
              if(type[1] != undefined){
                x.TYPEFILE = type[1].toUpperCase();
              } else {
                x.TYPEFILE = ""
              }
            }
            x.LOCKED == true ? x.LOCKED = "Yes" : x.LOCKED = "No"
            return x;
          });
          this.documentDataSourceOriginal = this.documentDataSource;
          if(this.GalleryImages==false){
            this.changeAcordeon("Images Pictures");
          }
        },error=>{
        });
      }
    }

    this.showTabs ? this.tabsClass = "col-md-12 hide-panel-tabs": '';
  }

  initDocumentForm() {
    this.uploadingFile = true;
    if(this.nameModule == 'EditEmployeeDocument'){
      this._documentForm = new FormGroup({
        name: new FormControl({ value: '', disabled: false }, [Validators.required]),
        documenttypeid: new FormControl({ value: "", disabled: false }, [Validators.required]),
        documentrevision: new FormControl({ value: null, disabled: false }, [Validators.required]),
        revisionnotes: new FormControl({ value: '', disabled: false }, []),
        description: new FormControl({ value: '', disabled: false }, []),
        attachment: new FormControl({ value: '', disabled: false }, []), //Nombre de file con extensión
        employeeid: new FormControl({ value: this.itemid, disabled: false }, []),
        optionFile: new FormControl({ value: this.valueOptionsFile, disabled: false }, []),
        id: new FormControl({ value: 0, disabled: false }, []),
        restricted: new FormControl({ value: false, disabled: false }, []),
      });
    }else{
      this._documentForm = new FormGroup({
        name: new FormControl({ value: '', disabled: false }, [Validators.required]),
        documenttypeid: new FormControl({ value: "", disabled: false }, [Validators.required]),
        documentrevision: new FormControl({ value: null, disabled: false }, [Validators.required]),
        revisionnotes: new FormControl({ value: '', disabled: false }, []),
        description: new FormControl({ value: '', disabled: false }, []),
        attachment: new FormControl({ value: '', disabled: false }, []), //Nombre de file con extensión
        projectid: new FormControl({ value: this.itemid, disabled: false }, []),
        optionFile: new FormControl({ value: this.valueOptionsFile, disabled: false }, []),
        id: new FormControl({ value: 0, disabled: false }, []),
        restricted: new FormControl({ value: false, disabled: false }, []),
      });
    }
    this._documentForm.addControl('hyperlink', new FormControl({ value: '', disabled: false }, []));
  }

  setDocumentForm(val) {
    this.actionDocument = 'Edit Document';
    this.getDocumentType();
    this._documentForm = new FormGroup({
      name: new FormControl({ value: this.insertDocument.name_id == 'assetid' ? val.DOCNAME : val.NAME, disabled: false }, [Validators.required]),
      documenttypeid: new FormControl({ value: val.DOCUMENTTYPEID != undefined && val.DOCUMENTTYPEID != 0 && val.DOCUMENTTYPEID != "" ? val.DOCUMENTTYPEID : "", disabled: false }, [Validators.required]),
      documentrevision: new FormControl({ value: val.REVISION, disabled: false }, [Validators.required]),
      revisionnotes: new FormControl({ value: val.REVISIONNOTES, disabled: false }, []),
      description: new FormControl({ value: val.DESCRIPTION, disabled: false }, []),
      attachment: new FormControl({ value: '', disabled: false }, []),
      projecttodoid: new FormControl({ value: '', disabled: false }, []),
      employeeid: new FormControl({ value: this.currentCustomerid, disabled: false }, []),
      optionFile: new FormControl({ value: this.valueOptionsFile, disabled: false }, []),
      id: new FormControl({ value: val.ID, disabled: false }, []),
      restricted: new FormControl({ value: val.RESTRICTED, disabled: false }, []),
    });

    this._documentForm.addControl('hyperlink', new FormControl({ value: val.HYPERLINK, disabled: false }, []))
    let upload;
    if(val.TYPEFILE!=='' && val.TYPEFILE!== null){
      this.uploadingFile = true;
      this.MapInformationService.GetDocument(val.FILEPATH).subscribe(result => {
        let typeMime=[]

        if(val.ATTACHMENT != undefined && val.ATTACHMENT != null){
          typeMime = val.ATTACHMENT.toString().split(".")
        } else {
          typeMime = ["","document"]
        }

        this.File = new File ([result.filestring], val.ATTACHMENT, {type:typeMime[1]});
        if(this.File!==null){

          this._documentForm.get('attachment').setValue(this.File.name);
          this.valueDocument = [this.File]
          this.attachment = result.filestring
          this.selectedFile = result.filestring
          this.changeBase64 = false;
        }
      })
      this.selectedTabPopup = 0;
      this.valueOptionsFile = this.optionsFile[0];
    }else{
      this.selectedTabPopup = 1;
    }
    this.externalLink = val.HYPERLINK;
  }

  // method: "InsertVisioDocument",
  // id: id,
  // systemid: systemid,
  // name: name,
  // documentrevision: documentrevision,
  // description: description,
  // revisionnotes: revisionnotes,
  // attachment: attachment,
  // codename: codename,
  // locked: locked == true ? 1:0,
  // doctypeid: doctypeid,
  // deleted: deleted == true ? 1:0,

//   attachment: "icons8-autocad-48.png"
// description: "des"
// documentrevision: 1
// documenttypeid: 3
// hyperlink: ""
// id: 0
// method: "InsertVisioDocument"
// name: "3123"
// optionFile: "Upload File to Cube"
// projectid: "2302"
// revisionnotes: "notes"
// systemid: 29781

  submitDocument(saveandnew = false) {
    let form = this._documentForm.value;

    if(this.selectedFile.length == 0 && this.externalLink.length == 0 ){
      this.toast.warning('Select a File to Save');
      return this._documentForm.invalid;
    }

    form[this.insertDocument.name_id] = this.itemid;

    if(this.itemid2 != undefined) {
      form[this.insertDocument.name_id] = this.itemid2;
    }

    this.projectid!==null && this.projectid!==undefined ? form.projectid = this.projectid : '';

    form.method = this.insertDocument.method;

    if(this.itemid2 != undefined) {
      form[this.insertDocument.name_id] = this.itemid2;
      // if ()
      // delete form.projectid
    }

    form.doctypeid = form.documenttypeid
    form.restricted = form.restricted == true ? 1 : 0
    console.log('FORM ', form);
    this.salesProjectService.InsertDocuments(form).subscribe(result=>{
      console.log('INSERTED BD ', result);
      this.popupDocument = false;

      if(result[0].ReturnID != undefined) {
        this.salesProjectService.SaveDocumentDinamico(form.name, this.selectedFile, result[0].ReturnID, this.insertDocument.doctype)
        .subscribe((resp)=>{
          if ((typeof result["result"] != "undefined") && (result["result"].toString() == '0')){
            this.resetFormAfterSubmit();
          }else{
            this.resetFormAfterSubmit();
          }
        },error=>{
          console.log('Error ', error);
          this.toast.error('Error');
        });

        // this.resetFormAfterSubmit();
      } else {
        // this.salesProjectService.SaveDocumentDinamico(form.name, this.selectedFile, result[0].ResultID, this.insertDocument.doctype)
        this.estimateService.SaveAttachment(this.selectedFile, result[0].ResultID)
        .subscribe((resp)=>{
          this.resetFormAfterSubmit();
        },error=>{
          this.resetFormAfterSubmit();
        });
      }

      this.externalLink = "";
      this.selectedFile = "";

    },error=>{
      this.resetFormAfterSubmit();
    })
  }

  resetFormAfterSubmit(){
    this.initDocumentForm();
    this.toast.success(this.translate.instant('msgDocInfoUpdSucc'));
    this.selectedFile = '';
    this.valueDocument=[];
    this.getProjectDocument();
  }

  getDocumentType() {
    if(this.nameModule == 'EditEmployeeDocument'){
      this.salesProjectService.GetProjectDocumentEditEmployeeDocumentType().subscribe(result => {
        console.log("🚀 ~ file: project-attached-document.component.ts:492 ~ ProjectAttachedDocumentComponent ~ this.salesProjectService.GetProjectDocumentEditEmployeeDocumentType ~ result:", result)
        this.documentTypeSelect = result.map(x=>{
          x.DESCRIPTION = x.ID + ' - ' + x.DOCNAME;
          return x;
        });
      });
    }else{
      if(this.insertDocument.name_id=='partid'){
        this.salesProjectService.GetProjectDocumentPartsType().subscribe(result => {
          console.log("🚀 ~ file: project-attached-document.component.ts:501 ~ ProjectAttachedDocumentComponent ~ this.salesProjectService.GetProjectDocumentPartsType ~ result:", result)
          this.documentTypeSelect = result.map(x=>{
            x.DESCRIPTION = x.ID + ' - ' + x.NAME;
            return x;
          });
        });
      }else{
        this.salesProjectService.GetProjectDocumentType().subscribe(result => {
          console.log("🚀 ~ file: project-attached-document.component.ts:509 ~ ProjectAttachedDocumentComponent ~ this.salesProjectService.GetProjectDocumentType ~ result:", result)
          this.documentTypeSelect = result.map(x => {
            x.DESCRIPTION = x.ID + ' - ' + x.DESCRIPTION;
            return x;
          });
        });
      }
    }
    
    console.log(this.documentTypeSelect);
  }

  getEmployee() {
    this.employee.GetAll().subscribe(result => {
      this.employeeSelect = result.map((val) => {
        return { // Return the new object structure
          label: val.CONTACTNAME,
          value: val.ID
        };
      });
    });
  }

  filterProjectDocument() {
    let result = [];

    result = this.documentDataSourceOriginal.filter(x =>
      x.NAME.toLowerCase().includes(this.filterAttachedDocument.name.toLowerCase())
    )

    if (this.filterAttachedDocument.revision) {
      result = result.filter(x => x.REVISION == this.filterAttachedDocument.revision);
    }

    if (this.filterAttachedDocument.documentType.length > 0) {
      result = result.filter(x => this.filterAttachedDocument.documentType.includes(x.DOCUMENTTYPEID));
    }

    if (this.filterAttachedDocument.createby.length > 0) {
      result = result.filter(x => this.filterAttachedDocument.createby.includes(x.CREATEDBY));
    }

    this.documentDataSource = result;
  }

  clearFilterProjectDocument() {
    this.filterAttachedDocument = {
      name: '',
      revision: '',
      documentType: [],
      createby: []
    }
    this.filterProjectDocument();
  }

  BorrarDocument(){
    this.valueDocument = [];
    this.selectedFile = '';
    this._documentForm.get('attachment').setValue('');
  }

  DownloadDocument(data,event){
    // data.data.FILEPATH
    // if (data.data.filepath != undefined){
    //   data.data.FILEPATH = data.data.filepath + data.data.File_Name
    // }

    var lfilepath = data.data.FILEPATH;

    this.MapInformationService.GetDocument(data.data.FILEPATH).subscribe(result => {
      let tipo = ""

      var data = result.filestring.substring(0, 5);

      switch(data.toUpperCase()){
        case "IVBOR":tipo = "png";
        break
        case "/9J/4":tipo = "jpeg";
        break
        case "JVBER":tipo = "pdf";
        break
        case "UESDB":
          var data2 = result.filestring.substring(0, 19);
          switch (data2.toUpperCase()) {
            case "UEsDBBQABgAIAAAAIQB": tipo = "xlsx";
              break
            default:
              var data3 = result.filestring.substring(0, 18);

              switch (data3.toUpperCase()) {
                case "UESDBBQABGAIAAAAIQ":  tipo = "docx";
                  break
                default: tipo = "zip";
              }
          }
          break
        case "UMFYI": tipo = "rar";
          break
        case "U1PKC": tipo = "txt";
          break
      }

      var theFilename = lfilepath.replace(/^.*[\\\/]/, '');

      var bytArray = Uint8Array.from(atob(result.filestring), c => c.charCodeAt(0));
      var blob = new Blob([bytArray], {type: "application/" + tipo });

      var link = document.createElement("a");
      link.download = theFilename;

      link.href = window.URL.createObjectURL(blob);
      link.click();
    })
  }

  // uploadDocument
  changeFile(ev) {
    if(this.changeBase64 && ev.value[0] && ev.value[0].size < 40000000){
      this._documentForm.get('attachment').setValue(ev.value[0].name);
      this.getBase64(ev.value[0]);
    } else {
      this.changeBase64 = true;
    }
  }

  getBase64(file) {
    const mythis = this
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      let data = reader.result.toString().split(",")
      mythis.attachment = data[1]
      mythis.selectedFile = data[1];
    };
    reader.onerror = function (error) {
    };
  }

  deleteDocumentGridModal(data){
    this.showModalDelete = true
    this.idDocument = data.ID
  }

  deleteDocumentGrid(){
    let info = {
      method:this.deleteDocument.method.trim(),
      [this.deleteDocument.name_id]:this.idDocument
    }

    this.MapInformationService.SaveInfoSites(info)
    .subscribe(resp=>{
      this.getProjectDocument()
      this.showModalDelete = false
    })
  }

  changeAcordeon(title){
    switch(title){
      case "Images Pictures":
      this.base64Imagenes = [];

        let images = this.documentDataSource.filter(el=>el.TYPEFILE=='JPG' || el.TYPEFILE=='JPEG' || el.TYPEFILE=='PNG');

          let imagesFinal = [];
          images.forEach(element => {
            if(element.FILEPATH != undefined){

              this.MapInformationService.DownloadDocument(element.FILEPATH).subscribe(result => {
                let tipo;
                let href;
                var data = result.filestring.substring(0, 5);
                let theFilename = element.FILEPATH.replace(/^.*[\\\/]/, '');

                switch(data.toUpperCase()){
                  case "/9J/4":
                    tipo = "jpeg";
                    href = 'data:image/jpg;base64,' + result.filestring
                  break
                  default:
                    tipo = "png"
                    href = 'data:image/png;base64,' + result.filestring
                  break
                }
                let informacion = {
                  tipo: tipo,
                  base64: href,
                  imageName: theFilename
                }
                if(result.filestring){
                  // this.base64Imagenes.push(informacion)
                  imagesFinal.push(informacion);
                  this.base64Imagenes = imagesFinal;
                }
              },error=>{
              })
            }
          });
      break
      case "Documents":
        this.getProjectDocument()
      break
    }
  }

  Openimage(base64, tipo){
    this.imagenFullScreen = base64;
    this.openModalFullScreen = true;
    this.tipoimagen = tipo;
  }

  PreviewDocument(data){

    // if(this.getDocument.name_id2 != undefined){
    //   data.FILEPATH += data.File_Name
    // }

    if(data.ATTACHMENT !== null && data.ATTACHMENT !== undefined && data.ATTACHMENT !== ''){
      var img = data.ATTACHMENT.split('.');

      img[1] = img[1].toUpperCase();

      if(img[1]=="PDF"){
        this.filePreview(data.FILEPATH, 'application/pdf');
      }else if (img[1]=="JPG" || img[1]=="PNG"){
        this.filePreview(data.FILEPATH, "image/"+ img[1].toLowerCase());
      }else{
        this.toast.info('This file is not available for preview');
      }
    }

  }

  filePreview(path, tipo){
    var lfilepath = path;

    this.MapInformationService.DownloadDocument(path).subscribe(result => {

      var theFilename = lfilepath.replace(/^.*[\\\/]/, '');

      var bytArray = Uint8Array.from(atob(result.filestring), c => c.charCodeAt(0));

      var blob = new Blob([bytArray], {type: tipo });

      var link = document.createElement("a");
      link.download = theFilename;

      link.href = window.URL.createObjectURL(blob);

      let path = this.sanitizer.bypassSecurityTrustUrl(link.href)

      this.previewFile = path;


      window.open(link.href);
    })
  }

  changeUploadFile(e){
    if(e.value=="Upload File to Cube"){
      this.uploadingFile = true;
    }else if (e.value=="Select External File"){
      this.uploadingFile = false;
    }
  }

  openGoogleDrivePicker(): void {
    this.googleDrivePickerService.open((data) => {
      if (data.action === 'picked') {
        this.externalLink = data.docs[0].url;
        this._documentForm.get('hyperlink').setValue(data.docs[0].url)
      }else if (data.details == "Cookies are not enabled in current environment."){
        this.dominioactual = document.domain;
        this.modalCookies = true;
      }
    })
  }

  closePopupDocument(){
    this.valueDocument=[];
    this.selectedFile = '';
    this.externalLink = '';
    this.selectedTabPopup = 0;
  }

  enableIconLink(e){

    if(e.length > 0){
      this.disableIconLink = true;
    }else{
      this.disableIconLink = false;
    }
    // this.editLinkButton.disabled = this.disableIconLink;
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'buttonsTask'
    });
    e.toolbarOptions.items.unshift({
      location: 'after',
      template: 'buttonsRight'
    });
  }

  collased:boolean=false
  closeParents(){
    this.GridDocuments.instance.collapseAll()
    this.collased = true
  }

  OpenParents(){
    this.GridDocuments.instance.expandAll()
    this.collased = false
  }

  filterValue: Array<any>;

  customizeColumns (columns) {
    let result = localStorage.getItem('GridDocuments');

    if(result){
      let data = JSON.parse(result);

      let finalColumns = columns.map((col, i) => {
        // data[i].name ? col.caption = data[i].name : '';
        data[i].dataField ? col.dataField = data[i].dataField : '';
        data[i].dataType ? col.dataType = data[i].dataType : '';
        col.visible = data[i].visible;
        col.visibleIndex = data[i].visibleIndex;
        data[i].width ? col.width = data[i].width : '';
        return col;
      });
      return finalColumns
    }
  }

  FirtsTime:boolean = true

  GetFilters(data){
    // if (data.component.option("filterValue")){

    //   localStorage.setItem('filterTaskEditProject' + this.parentProjectId, JSON.stringify(data.component.option("filterValue")));
    // } else {
    //   localStorage.setItem('filterTaskEditProject' + this.parentProjectId, JSON.stringify(data.component.option("filterValue")));
    //   this.filterValue = []
    // }
    console.log(this.collased)

    if (this.FirtsTime){
      if (this.collased){
        this.closeParents()
      } else {
        this.OpenParents()
      }
      this.FirtsTime = false
    }
  }


  actualState: any = 0;
  gridId: any = "DocumentsGrid";

  saveState1 = (state) => {
    

    let extraconfig = {
      collased : this.collased == true ? 1 : 0
    }
    
      if(this.actualState == 0){
        console.log("guardando")
        this.ProjectService.InsertUpdateGridConfiguration(0, this.gridId, state.filterValue, JSON.stringify(state.columns), JSON.stringify(extraconfig) ).subscribe(result=>{
          return state;
        })
      }else if(this.actualState.ID){
        console.log("guardando")
        this.ProjectService.InsertUpdateGridConfiguration(this.actualState.ID, this.gridId, state.filterValue, JSON.stringify(state.columns), JSON.stringify(extraconfig) ).subscribe(result=>{
          return state;
        })
      }
  }


}
